import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return; done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        window.history.replaceState(null, "", "/");
        const r = data.user.role;
        nav(["super_admin","owner","store_manager","staff","salesman","technician"].includes(r) ? "/erp" : r === "seller" ? "/become-seller" : "/");
      } catch { nav("/login"); }
    })();
  }, []);
  return <div className="min-h-screen flex items-center justify-center text-slate-500">Signing you in…</div>;
}
